import React from 'react';
import { Route } from 'react-router-dom';
import { PrivateRoute } from '@/routes/guards';
import { lazyWithRetry } from '@/routes/utils';

const Dashboard = lazyWithRetry(() => import('@/pages/dashboard/Dashboard'));
const Settings = lazyWithRetry(() => import('@/pages/dashboard/Settings'));
const Contact = lazyWithRetry(() => import('@/pages/dashboard/Contact'));
const Account = lazyWithRetry(() => import('@/pages/dashboard/Account'));
const PublicProfile = lazyWithRetry(() => import('@/pages/dashboard/PublicProfile'));
const Team = lazyWithRetry(() => import('@/pages/dashboard/Team'));
const TeamAudit = lazyWithRetry(() => import('@/pages/dashboard/TeamAudit'));

export const dashboardRoutes = (
  <>
    <Route
      path="/dashboard"
      element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      }
    />
    <Route
      path="/settings"
      element={
        <PrivateRoute>
          <Settings />
        </PrivateRoute>
      }
    />
    <Route
      path="/account"
      element={
        <PrivateRoute>
          <Account />
        </PrivateRoute>
      }
    />
    <Route
      path="/team"
      element={
        <PrivateRoute>
          <Team />
        </PrivateRoute>
      }
    />
    <Route
      path="/team/audit"
      element={
        <PrivateRoute>
          <TeamAudit />
        </PrivateRoute>
      }
    />
    <Route path="/contact" element={<Contact />} />
    <Route path="/users/:username" element={<PublicProfile />} />
    <Route path="/gminy/:username" element={<PublicProfile />} />
  </>
);
